import Box from "@mui/material/Box";
import ThemeContext from "components/app/Context";
import Basictabs from "components/common/Tabs";
import { useTranslate } from "hooks/useTranslate";
import { useContext } from "react";
import { tokens } from "styles/Tokens";
import BookmarkedPlans from "../BookmarkedPlans";
import AssignedLibraryPlans from "./AssignedLibraryPlans";
import AssignedCustomPlans from "./AssignedTemplatePlans";
import BrandDeadline from "./BrandDeadline";
import BrandInitiative from "./BrandInitiatives";

const PlanView = () => {
  const translate = useTranslate();
  const { isMobileScreen } = useContext(ThemeContext);
  const tabDetails = [
    { label: translate("dashboard.assigned.progress.completed"), content: AssignedLibraryPlans },
    { label: translate("dashboard.assigned.templatePlans"), content: AssignedCustomPlans },
    { label: translate("dashboard.brand.deadlines"), content: BrandDeadline },
    { label: translate("dashboard.initiatives"), content: BrandInitiative }
  ];

  return (
    <>
      {isMobileScreen && (
        <>
          <BookmarkedPlans />
          <Box sx={{ mb: "32px" }} />
        </>
      )}
      <Basictabs
        tabDetails={tabDetails}
        alignItems="left"
        labelVariant="body2"
        isChildTab
        backgroundColor={tokens.Background.General.Primary}
        marginBottom="0"
      />
    </>
  );
};

export default PlanView;
